<div class="alert-page p-1 p-md-3">
    <h2 class="visually-hidden">Alert</h2>
    <div class="alert-page__header">
        <a routerLink="/alerts">Active alerts</a>
        <button mat-stroked-button type="button" (click)="refresh()">Refresh</button>
    </div>

    @if (notFound()) {
        <h3>Alert not found</h3>
        <p>
            The link may be incomplete or from another environment, or the alert was resolved and has since been
            deleted.
        </p>
    }

    @if (loadFailed()) {
        <div class="alert-page__error" role="alert">The alert could not be loaded. Refresh to try again.</div>
    }

    @if (alert(); as alert) {
        <app-alert-card [alert]="alert" (changed)="refresh()" />
    }
</div>
